import React from "react";
export const GridCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.96738 2.05156C3.02625 1.99269 3.05569 1.96325 3.08162 1.93942C3.71925 1.35353 4.69934 1.35353 5.33697 1.93942C5.3629 1.96325 5.39234 1.99269 5.45121 2.05156L6.66637 3.26672C7.33475 3.9351 7.52591 4.94446 7.14821 5.81095C6.77051 6.67744 6.96166 7.6868 7.63004 8.35518L9.62738 10.3525C10.2958 11.0209 11.3051 11.2121 12.1716 10.8344C13.0381 10.4567 14.0475 10.6478 14.7158 11.3162L15.931 12.5314C15.9899 12.5902 16.0193 12.6197 16.0431 12.6456C16.629 13.2832 16.629 14.2633 16.0431 14.9009C16.0193 14.9269 15.9899 14.9563 15.931 15.0152L15.1924 15.7538C14.5909 16.3553 13.7238 16.6078 12.8934 16.4233C7.2354 15.1659 2.81662 10.7472 1.55929 5.08917C1.37476 4.25878 1.62726 3.39167 2.22876 2.79018L2.96738 2.05156Z"
        stroke="#245CEA"
        stroke-width="1.5"
      />
    </svg>
  );
};
